import { Link } from "react-router-dom";

const claimsFeatures = [
  {
    icon: "ri-hospital-line",
    title: "Cashless Claims",
    description: "Direct tie-ups with 15,000+ network hospitals for hassle-free cashless treatment.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Documentation Support",
    description: "We handle all paperwork, from claim forms to medical reports and insurer communication.",
  },
  {
    icon: "ri-search-line",
    title: "Claim Tracking",
    description: "Real-time tracking of your claim status with regular updates at every processing stage.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Escalation Support",
    description: "If claims are delayed or rejected, our experts escalate and fight for your rightful settlement.",
  },
  {
    icon: "ri-money-rupee-circle-line",
    title: "Reimbursement Help",
    description: "Complete guidance for reimbursement claims including document verification and follow-ups.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Settlement Assistance",
    description: "End-to-end support until the claim amount is credited to your account. Zero stress for you.",
  },
];

export default function ClaimsPreviewSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-emerald-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block bg-emerald-100 text-emerald-700 text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-3">
              Claims Assistance
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-4">
              We Stand By You When It Matters Most
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-8">
              Buying insurance is easy. Claiming it is hard. That&apos;s why our relationship doesn&apos;t end at purchase.
              Our dedicated claims team ensures you get your rightful settlement without the stress and confusion.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mb-8">
              {claimsFeatures.slice(0, 4).map((feature, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <div className="w-9 h-9 rounded-lg bg-emerald-100 text-emerald-600 flex items-center justify-center shrink-0">
                    <i className={`${feature.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-slate-900">{feature.title}</h4>
                    <p className="text-xs text-slate-500 mt-0.5">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/claims-assistance"
              className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-sm px-6 py-3 rounded-full transition-colors shadow-md"
            >
              <i className="ri-shield-check-line"></i>
              Learn About Claims Support
            </Link>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl bg-gradient-to-br from-emerald-100 to-teal-200 min-h-[300px] md:min-h-[400px] flex items-center justify-center">
              <div className="text-center p-8">
                <div className="w-20 h-20 rounded-full bg-white/80 flex items-center justify-center mx-auto mb-4 shadow-sm">
                  <i className="ri-shield-check-line text-4xl text-emerald-600"></i>
                </div>
                <p className="text-emerald-800 font-semibold text-lg">Dedicated Claims Support</p>
                <p className="text-emerald-600 text-sm mt-1">End-to-end assistance from filing to settlement</p>
              </div>
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-white rounded-xl shadow-lg border border-slate-100 p-4 md:p-5">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center">
                  <i className="ri-check-double-line text-2xl"></i>
                </div>
                <div>
                  <p className="text-xl md:text-2xl font-extrabold text-slate-900">97.8%</p>
                  <p className="text-xs text-slate-500">Claim Success Rate</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}